import React, { useMemo } from 'react';
import { useGetRolesInfinite } from '@area-restrita/api-client/endpoints/roles/roles.gen';

import Select, { ISelectProps, SelectOption } from '../Select';
import { RoleWithIdDto } from '@area-restrita/api-client/model/roleWithIdDto';

const toSelectOption = (department: RoleWithIdDto): SelectOption => ({
  label: department.name,
  value: department.id,
});

type IRoleSelectorProps = Omit<ISelectProps, 'options'>;

const RoleSelector: React.FC<IRoleSelectorProps> = (props) => {
  const query = useGetRolesInfinite(
    { limit: 100, page: 1 },
    {
      query: {
        getNextPageParam: (lastPage, _, lastPageParam) =>
          lastPage.data.length > 0 ? lastPageParam + 1 : null,
      },
    },
  );

  const roles = useMemo(
    () =>
      query.data?.pages.flatMap<SelectOption>((page) =>
        page.data.map(toSelectOption),
      ) ?? [],
    [query.data],
  );

  return (
    <Select {...(props as ISelectProps)} options={roles} plural="funções" />
  );
};

export default RoleSelector;
